import { mdiHelpCircleOutline } from '@mdi/js'

export default {
  title: 'FAQ',
  to: 'faq-admin',
  icon: mdiHelpCircleOutline,
  resource: 'FaqAdmin',
  action: 'read',
}
